import { __untypedExpression } from '@/js/stores/expressions';
import { ChannelName } from './types';

export const channelNameTranslations: Record<ChannelName, string> = {
    [ChannelName.CALL]: 'channel-name-call',
    [ChannelName.CALLBACK]: 'channel-name-callback',
    [ChannelName.OUTGOING_CALL]: 'channel-name-outgoing-call',
    [ChannelName.MAIL]: 'channel-name-mail',
    [ChannelName.CHAT]: 'channel-name-chat',
    [ChannelName.NO_INTERACTION]: 'channel-name-no-interaction',
};

export const getChannelLabel = (channelName: ChannelName): string =>
    channelNameTranslations[channelName]
        ? __untypedExpression(channelNameTranslations[channelName])
        : channelName;
